import React from 'react';

import LazyImgixImage from '@components/LazyImgixImage';
import useEventTracking from '@hooks/useEventTracking';
import { article_path } from '@routes';
import { ClickTarget, ContentType, click } from '@tracking';
import { articlePath } from '@utils/queryStringHelper';

import type { RecommendedArticlesBlockProps } from './interfaces';

const ArticleItem = ({
  article: { authors, id, picture_url_small, slug, title, newsletterSlug },
}: RecommendedArticlesBlockProps) => {
  const { trackEvent } = useEventTracking({
    contentType: ContentType.Article,
  });

  const handleArticleClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.ArticleImage, contentId: id }));
  };

  const handleArticleTitleClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.Headline, clickText: title, contentId: id }));
  };

  return (
    <div className="min-w-[65svw] flex-1 sm:min-w-[calc(50svw-72px)] nav:min-w-0">
      <a
        href={article_path(slug)}
        className="relative mb-8 block aspect-[16/9] sm:mb-0"
        onClickCapture={handleArticleClick}
      >
        <LazyImgixImage
          className="m-auto block aspect-[16/9] h-auto w-full"
          src={picture_url_small}
          sizes="(min-width: 768px) 250px, (min-width: 480px) 500px, 400px"
          wrapperClassName="h-full w-full"
        />
      </a>
      <div className="mt-16">
        <h2 className="pro-article-title m-0 font-suisse-intl text-body-md font-normal text-primary-black sm:font-suisse-works sm:text-headline-xxs">
          <a
            href={articlePath({ slug: slug, newsletterSlug: newsletterSlug })}
            className="text-primary-black"
            onClickCapture={handleArticleTitleClick}
          >
            {title}
          </a>
        </h2>
        <p className="mb-0 mt-8 !font-suisse-screen !text-byline-sm font-normal text-primary-black">
          By {authors}
        </p>
      </div>
    </div>
  );
};

export default ArticleItem;
